import { useRef, type MutableRefObject } from 'react';

/**
 * Returns a ref that always holds the latest value of the given argument.
 */
const useLatestRef = <T,>(value: T): MutableRefObject<T> => {
	const ref = useRef<T>(value);
	// Synchronous assignment ensures ref.current is always up-to-date
	ref.current = value;
	return ref;
};

export default useLatestRef;
